function toggleSubscription(e) {
    if (e) {
        if ($('.subscription-time').hasClass('d-none')) {
            $('.subscription-switch .form-check-input').attr('checked', true);
            $('.subscription-time').removeClass('d-none');
        }
        else {
            $('.subscription-switch .form-check-input').attr('checked', false);
            $('.subscription-time').addClass('d-none');
        }
    }
}
module.exports = {
    toggle: toggleSubscription
};
